import { render } from "./About.vue?vue&type=template&id=7a4d186c"
const script = {}
script.render = render

export default script